import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadProducts = async () => {
  try {
    const response = await Axios.get('products');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadProductForSells = async (pos_id) => {
  try {
    const response = await Axios.get('products/location/'+pos_id);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};


const loadOneProduct = async (name) => {
  try {
    const respnse = await Axios.get('products/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadProduct = async (action) => {
  try {
    switch (action) {
      case 'new':
        const respnse = await Axios.get('setups/products/');
        const responseData = await respnse.data;
        return {...responseData, product: {}};
        // return {categories:[], tags:[], product:[], routes:[], product:{}}
        
      default:
        const data = await loadOneProduct(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useProductAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('products', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('product_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('products/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }

  const getTaxes = async () => {
    try {
      const response = await fetch('http://localhost:7900/taxes/all/sales-taxes', {
        method: 'GET',
        credentials: 'include'
      });
      const responseData = await response.json();
      return responseData;
    }catch (err) {
      throw err;
    }
  }

  // getTaxes = async () => {
  //   try {
  //     const response = await fetch('http://localhost:7900/taxes/all/sales-taxes', {
  //       method: 'GET',
  //       credentials: 'include'
  //     });
  //     const responseData = await response.json();
  //     return responseData;
  //   }catch (err) {
  //     throw err;
  //   }
  // }

  return { create, update, getTaxes };
};



export default useProductAPI;


